import { JSX } from 'preact';
import clsx from 'clsx';

export type ButtonProps = JSX.IntrinsicElements['button'] & {
  variant?: 'default' | 'outline' | 'primary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'xl' | 'icon';
  active?: boolean;
};

export function Button({
  variant = 'default',
  size = 'default',
  active = false,
  type = 'button',
  className,
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      {...props}
      class={clsx(
        'button',
        {
          'button-primary': variant === 'primary',
          'button-outline': variant === 'outline',
          'button-link': variant === 'link',
          'button-ghost': variant === 'ghost',
          'button-active': active,
          'button-sm': size === 'sm',
          'button-lg': size === 'lg',
          'button-xl': size === 'xl',
          'button-icon': size === 'icon',
        },
        className,
      )}
    />
  );
}
